var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTrashSolid = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  viewBox: "8 7 14 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M17.996 19.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5zm-4 0a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5zm-1-9.5h4V9h-4zm8.008 0h-2.008V8c0-.55-.443-1-.992-1h-6c-.55 0-1.008.45-1.008 1v2H9.004C8.454 10 8 10.45 8 11s-.004 1 .996 1v10c0 .55.458 1 1.008 1h10c.549 0 .992-.45.992-1V12c1 0 1.004-.45 1.004-1a1 1 0 0 0-.996-1"
})));
export default SvgTrashSolid;